import { render, staticRenderFns } from "./bancontact-payment-modal.vue?vue&type=template&id=ac03ba94&scoped=true&"
import script from "./bancontact-payment-modal.ts?vue&type=script&lang=ts&"
export * from "./bancontact-payment-modal.ts?vue&type=script&lang=ts&"
import style0 from "./bancontact-payment-modal.scss?vue&type=style&index=0&id=ac03ba94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac03ba94",
  null
  
)

export default component.exports